import { useState } from 'react';
import { FileType } from './index';
import { formatBytes } from '../../../utils';

export default function useFileUploader(showPreview: boolean = true) {
    const [selectedFiles, setSelectedFiles] = useState<FileType[]>([]);

    /**
     * Handled the accepted files and shows the preview
     */
    const handleAcceptedFiles = (files: FileType[], callback?: (files: FileType[]) => void) => {
        let allFiles = files;

        if (showPreview) {
            files.map((file) =>
                Object.assign(file, {
                    preview: file['type'].split('/')[0] === 'image' ? URL.createObjectURL(file) : null,
                    formattedSize: formatBytes(file.size),
                }),
            );

            allFiles = [...selectedFiles];
            allFiles.push(...files);
            setSelectedFiles(allFiles);
        }

        if (callback) callback(allFiles);
    };

    /*
     * Removes the selected file
     */
    const removeFile = (file: FileType) => {
        const newFiles = [...selectedFiles];
        newFiles.splice(newFiles.indexOf(file), 1);
        setSelectedFiles(newFiles);
    };

    return {
        selectedFiles,
        handleAcceptedFiles,
        removeFile,
    };
}
